import React from "react";

import { SkeletonBlock } from "../../../../Skeletons/primitives";

/**
 * Template card skeleton — replaces absolute-positioned Skeleton.Input.
 * Uses flex layout for responsive rendering.
 */
const SelectTemplateLoading = ({ customKey }) => {
  return (
    <div className="flex w-full overflow-hidden" key={customKey}>
      <div
        className="flex items-center gap-3 rounded-lg p-3"
        style={{ background: "var(--skeleton-bg)", width: 293, minHeight: 50 }}
      >
        <SkeletonBlock
          width="65%"
          height={27}
          radius="sm"
          style={{ background: "var(--skeleton-shine)" }}
        />
      </div>
    </div>
  );
};

export default SelectTemplateLoading;
